const styles = {
    paddingX: "sm:px-16 px-6",
    paddingY: "sm:py-16 py-6",
    padding: "sm: px-16 px-6 sm:py-5 py-5",


    heroHeadText: 
    "font-black text-white lg:text-[80px] sm:text-[60px] xs:text-[50px] text-[40px] lg:leading-[40px]",
    heroSubText:
    "text-[#dfd9ff] font-medium lg:text-[20px] sm:text=[26px] xs:text-[20px] text-[16px] lg:leading-[40px]",
    sectionHeadText:
    "text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",
    sectionSubtext:
    "sm:text-[18px] text-[14px] text-secondary uppercase tracking-wider",


};

export {styles}